import React from 'react';
import { FileOrFormQuestion } from '../FileOrFormQuestion';
import { usePropertySpecSheetFile } from '../../../../queries/PropertyFileFields/NonRentalFiles';
import { formConstant } from '../constants/FormConstant';

interface SpecSheetFileParameter {
    disableEditFormOptionSpecSheet?: boolean;
    propertyGuid: string;
    required: boolean;
    isReview?: boolean;
}

export const SpecSheetFile: React.FC<SpecSheetFileParameter> = ({
    disableEditFormOptionSpecSheet,
    required,
    propertyGuid,
    isReview = false,
}) => {
    const { handleMode, setHandleMode, filename: uploadFileName, setFilename: setUploadFileName, fileApiId: uploadedFileApiId, setFileApiId: setUploadedFileApiId } = usePropertySpecSheetFile(propertyGuid);

    return (
        <div className='form-group'>
            <div className='row'>
                <FileOrFormQuestion
                    label={formConstant.displayName.specSheet}
                    selector='specSheet'
                    formTypeName={formConstant.displayName.specSheet}
                    fileType='spec sheet'
                    disableEditFormOption={disableEditFormOptionSpecSheet}
                    required={required}
                    isReview={isReview}
                    propertyGuid={propertyGuid}
                    handle={handleMode}
                    onHandleChange={setHandleMode}
                    uploadFileName={uploadFileName}
                    onUploadFileNameChange={setUploadFileName}
                    uploadedFileApiId={uploadedFileApiId}
                    onUploadedFileApiIdChange={setUploadedFileApiId}
                />
            </div>
        </div>
    );
};
